// https://github.com/vuejs/vue/issues/5886#issuecomment-308647738

let uuid = 0;

export default {
  beforeCreate() {
    this.uuidString = uuid.toString();
    uuid += 1;
  },
  computed: {
    uuid() {
      return this.uuidString;
    },
  },
};
